/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import RcCheckbox, { Props } from "rc-checkbox";
import cx from "classnames";

import styles from "./Checkbox.module.scss";

const InitializedCheckbox = RcCheckbox;

export const Checkbox = ({ className, ...props }: Props) => (
  <InitializedCheckbox className={cx(styles.checkbox, className)} {...props} />
);

export default Checkbox;
